import { FC, useState, useReducer, useEffect } from 'react'
import { Box, Grid, TextField, Typography } from '@mui/material'

import { AccountTnc } from '../../../../services'

// Components
import { AppDialog } from '../../../../components'

// Redux
import { useAppDispatch, useAppSelector } from '../../../../hooks'
import { showAlertAction } from '../../../../store/alerts'
import { getTncAction, updateTncAction, updateTncResetAction } from '../../../../store/tnc'

export interface AddEditBodyProps {
  children?: React.ReactNode
  onClose?: () => void
  accountTnc: AccountTnc
}

export const AddEditBodyItem: FC<AddEditBodyProps> = ({
  onClose,
  accountTnc,
}) => {
  const dispatchAction = useAppDispatch()
  const {
    success,
    message,
  } = useAppSelector((state) => state.updateAccountTncState)
 
  const [isClose, setClosePopup] = useState<boolean>(false)
  const [body, setBody] = useState<string>(null)
  const [bodyError, setBodyError] = useState(false)

  
  useEffect(() => {
    if (success) {
      dispatchAction(getTncAction(accountTnc.account.id))
      dispatchAction(
        showAlertAction({
          message: 'Quotation Body Updated Successfully',
          severity: 'success',
        })
      )
      onClose() // To close the popup
    } else if (message) {
      dispatchAction(showAlertAction({ message: message, severity: 'error' }))
    }
  }, [success, message])

  const onChangeHandler = (e) => {
     setBodyError(false)
     setBody(e.target.value)
  }

  const submitHandle = () => {
     accountTnc.body = body
     dispatchAction(updateTncAction(accountTnc)) 
  }

  useEffect(() => {
    if(accountTnc) {
      setBody(accountTnc.body)
    }
    return () => {
      dispatchAction(updateTncResetAction()) 
    }
  }, [])
  return (
    <AppDialog
      disableEnter={true}
      id="edit-body"
      title={'Quotation Body'}
      submitButtonText="Submit"
      onClose={onClose}
      onSubmit={submitHandle}
      close={isClose}
      maxWidth="md"
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
      >
        <Grid item xs={12} mr={2}>
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { m: 1 },
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container spacing={1} mt={0.5}>
              <Grid item={true} xs={12}>
                <Typography sx={{pb:2, pl:1, fontWeight:700}}>You can create table like this(comma separated): </Typography>
                 <Typography sx={{pl:1}}>Header1, Header2, Header3</Typography>
                 <Typography sx={{pl:1}}>Row1, Row2, Row3</Typography>
              </Grid>
              <Grid item={true} xs={12}>
                <TextField
                    size='small'
                  name="body"
                  value={body}
                  label="Quotation Body"
                  onChange={onChangeHandler}
                  fullWidth
                  multiline
                  inputProps={{ maxLength: 8000}}
                  error={bodyError}
                
                />
              </Grid>
            </Grid>
           
          </Box>
        </Grid>{' '}
      </Grid>
    </AppDialog>
  )
} 